import React from "react";

/**
 * Context to hold the current connection to the Firebase authentication server
 * @type {React.Context<null>}
 */
const FirebaseContext = React.createContext(null);

export default FirebaseContext;
